import { render, staticRenderFns } from "./LoadIndicator.vue?vue&type=template&id=0b77b7dd&scoped=true&lang=pug"
import script from "./LoadIndicator.vue?vue&type=script&lang=js"
export * from "./LoadIndicator.vue?vue&type=script&lang=js"
import style0 from "./LoadIndicator.vue?vue&type=style&index=0&id=0b77b7dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b77b7dd",
  null
  
)

export default component.exports